export const HandoffActionGraphic = () => (
  <svg width="124" height="85" viewBox="0 0 124 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M62 40.5C62 48.3152 62 39.5 62 52" stroke="#979EAA" strokeDasharray="1.71 1.71" />
    <path
      d="M16 52V48.5891C16 44.3977 19.3977 41 23.5891 41H101.411C105.602 41 109 44.3977 109 48.5891V52"
      stroke="#979EAA"
      strokeDasharray="1.71 1.71"
    />
    <path
      d="M1 77.1454V60.382L15.6227 54.6758L31.1056 60.382V77.1454L15.6227 83.4911L1 77.1454Z"
      fill="#F9FAFB"
      fillOpacity="0.65"
    />
    <path
      d="M1 60.382V77.1454L15.6227 83.4911M1 60.382L15.6227 54.6758L31.1056 60.382M1 60.382L15.6227 66.718M15.6227 83.4911L31.1056 77.1454V60.382M15.6227 83.4911V66.718M31.1056 60.382L15.6227 66.718"
      stroke="#979EAA"
      strokeWidth="0.55"
    />
    <path
      d="M46 77.5754V60.8121L62.1613 54.6758L76.1056 60.8121V77.5754L61.0528 84.0755L46 77.5754Z"
      fill="#F9FAFB"
      fillOpacity="0.65"
    />
    <path
      d="M46 60.8121V77.5754L61.0528 84.0755M46 60.8121L62.1613 54.6758L76.1056 60.8121M46 60.8121L61.0528 67.3122M61.0528 84.0755L76.1056 77.5754V60.8121M61.0528 84.0755V67.3122M76.1056 60.8121L61.0528 67.3122"
      stroke="#979EAA"
      strokeWidth="0.55"
    />
    <path
      d="M93.0039 77.5754V60.8121L109.165 54.6758L123.11 60.8121V77.5754L108.057 84.0755L93.0039 77.5754Z"
      fill="#F9FAFB"
      fillOpacity="0.65"
    />
    <path
      d="M93.0039 60.8121V77.5754L108.057 84.0755M93.0039 60.8121L109.165 54.6758L123.11 60.8121M93.0039 60.8121L108.057 67.3122M108.057 84.0755L123.11 77.5754V60.8121M108.057 84.0755V67.3122M123.11 60.8121L108.057 67.3122"
      stroke="#979EAA"
      strokeWidth="0.55"
    />
    <rect
      x="43.2809"
      y="0.275"
      width="37.4751"
      height="27.725"
      rx="7.09724"
      fill="#F9FAFB"
      stroke="#D1D5DB"
      strokeWidth="0.55"
    />
    <path
      d="M62.0192 14.6668C63.2846 14.6668 64.4354 15.0333 65.282 15.5498C65.7045 15.8076 66.0657 16.1118 66.3266 16.4424C66.5833 16.7672 66.7724 17.1559 66.7724 17.5715C66.7724 18.0178 66.5553 18.3695 66.2427 18.6204C65.9469 18.858 65.5566 19.0154 65.1421 19.1252C64.3087 19.3455 63.1964 19.4199 62.0192 19.4199C60.8421 19.4199 59.7298 19.346 58.8964 19.1252C58.4819 19.0154 58.0916 18.858 57.7958 18.6204C57.4826 18.369 57.2661 18.0178 57.2661 17.5715C57.2661 17.1559 57.4552 16.7672 57.7119 16.4418C57.9727 16.1118 58.3335 15.8081 58.7565 15.5493C59.6031 15.0339 60.7544 14.6668 62.0192 14.6668ZM62.0192 8.85742C62.7196 8.85742 63.3912 9.13563 63.8865 9.63084C64.3817 10.1261 64.6599 10.7977 64.6599 11.4981C64.6599 12.1984 64.3817 12.87 63.8865 13.3653C63.3912 13.8605 62.7196 14.1387 62.0192 14.1387C61.3189 14.1387 60.6473 13.8605 60.152 13.3653C59.6568 12.87 59.3786 12.1984 59.3786 11.4981C59.3786 10.7977 59.6568 10.1261 60.152 9.63084C60.6473 9.13563 61.3189 8.85742 62.0192 8.85742Z"
      fill="#6B7280"
    />
    <path
      d="M70.3082 7.80078L67.8702 10.2388L66.4082 8.77599"
      stroke="#6B7280"
      strokeWidth="1.17"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.813 35.7816C64.813 35.7816 62.9182 30.8997 62.7596 30.6285C62.6011 30.3574 62.4364 30.2107 62.1466 30.2339C61.9093 30.2529 61.7135 30.4306 61.6248 30.6596L58.9989 36.7739C58.891 37.0251 58.9352 37.3158 59.1129 37.5234C59.29 37.7304 59.5893 37.7817 59.8251 37.6455L61.7205 36.5509C61.9589 36.4133 62.2532 36.4157 62.4893 36.5573L64.3171 37.6535C64.5582 37.7982 64.8634 37.7796 65.0853 37.6068C65.2879 37.4489 65.3624 37.1763 65.2682 36.9372L64.813 35.7816Z"
      fill="#6B7280"
    />
  </svg>
);
